import { InstallProperties, MetadataSerialization } from '@adaptiva/metadata/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseFormAuthoringComponent } from './base-form-authoring.component';

@Component({
	standalone: false,
	selector: 'ada-install-properties',
	templateUrl: './form-authoring-template.html',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class InstallPropertiesComponent extends BaseFormAuthoringComponent<InstallProperties> {

	public override propertyConstructor: MetadataSerialization.Deserializable<InstallProperties> = InstallProperties;

}
